'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPublished = exports.isPublishFailed = exports.isUnpublished = exports.isStatus = exports.isEqual = exports.isType = exports.applyTimestampOffset = exports.setTimestamp = exports.getSenderType = exports.getSenderId = exports.getStatus = exports.getClientTs = exports.getTimestamp = exports.getType = exports.KEY_PATHS = undefined;
exports.isOlder = isOlder;
exports.getMessageGroup = getMessageGroup;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _immutable = require('immutable');

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _PubNubMessageStatusTypes = require('conversations-schema/constants/PubNubMessageStatusTypes');

var _PubNubMessageStatusTypes2 = _interopRequireDefault(_PubNubMessageStatusTypes);

var _PubNubMessageGroups = require('conversations-schema/constants/PubNubMessageGroups');

var _PubNubMessageGroups2 = _interopRequireDefault(_PubNubMessageGroups);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PUBLISHED = _PubNubMessageStatusTypes2.default.PUBLISHED,
    PUBLISH_FAILED = _PubNubMessageStatusTypes2.default.PUBLISH_FAILED,
    UNPUBLISHED = _PubNubMessageStatusTypes2.default.UNPUBLISHED;


function compareKeyPaths(_ref) {
  var keyPaths = _ref.keyPaths,
      message = _ref.message,
      other = _ref.other;

  var getHashCode = function getHashCode(messageToCompare) {
    return keyPaths.reduce(function (map, keyPath) {
      return map.set(keyPath, (0, _getIn2.default)(keyPath, messageToCompare));
    }, (0, _immutable.Map)()).hashCode();
  };

  return getHashCode(message) === getHashCode(other);
}

var KEY_PATHS = exports.KEY_PATHS = {
  TIMESTAMP: ['timestamp'],
  STATUS: ['status'],
  TYPE: ['metadata', _PubNubMessageTypes.MESSAGE_TYPE_ID],
  CLIENT_TS: ['clientTs'],
  SENDER_ID: ['senderId'],
  SENDER_TYPE: ['senderType']
};

var getType = exports.getType = (0, _getIn2.default)(KEY_PATHS.TYPE);

var getTimestamp = exports.getTimestamp = (0, _getIn2.default)(KEY_PATHS.TIMESTAMP);

var getClientTs = exports.getClientTs = (0, _getIn2.default)(KEY_PATHS.CLIENT_TS);

var getStatus = exports.getStatus = (0, _getIn2.default)(KEY_PATHS.STATUS);

var getSenderId = exports.getSenderId = (0, _getIn2.default)(KEY_PATHS.SENDER_ID);

var getSenderType = exports.getSenderType = (0, _getIn2.default)(KEY_PATHS.SENDER_TYPE);

var setTimestamp = exports.setTimestamp = (0, _curry2.default)(function (timestamp, message) {
  return message.setIn(KEY_PATHS.TIMESTAMP, timestamp);
});

var applyTimestampOffset = exports.applyTimestampOffset = (0, _curry2.default)(function (offsetInMs, message) {
  return message.updateIn(KEY_PATHS.TIMESTAMP, function (timestamp) {
    return timestamp + offsetInMs;
  });
});

var isType = exports.isType = (0, _curry2.default)(function (type, message) {
  return getType(message) === type;
});

var isEqual = exports.isEqual = (0, _curry2.default)(function (message, other) {
  if (message.senderId && message.clientTs) {
    return compareKeyPaths({
      keyPaths: [KEY_PATHS.SENDER_ID, KEY_PATHS.CLIENT_TS],
      message: message,
      other: other
    });
  }

  return compareKeyPaths({
    keyPaths: [KEY_PATHS.TYPE, KEY_PATHS.TIMESTAMP],
    message: message,
    other: other
  });
});

function isOlder(message, other) {
  return getTimestamp(message) > getTimestamp(other);
}

var isStatus = exports.isStatus = (0, _curry2.default)(function (status, message) {
  return getStatus(message) === status;
});

var isUnpublished = exports.isUnpublished = isStatus(UNPUBLISHED);

var isPublishFailed = exports.isPublishFailed = isStatus(PUBLISH_FAILED);

var isPublished = exports.isPublished = isStatus(PUBLISHED);

function getMessageGroup(message) {
  if (isUnpublished(message)) return _PubNubMessageGroups2.default.PUBLISHING;
  return _PubNubMessageGroups2.default.HISTORY;
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/models/PubNubMessageModel.js
// module id = 15
// module chunks = 0 1